<template>
  <oct-dialog
    full
    :title="$route.meta.title"
    :action="{
      text: '削除',
      type: 'danger'
    }"
    :icon="back.name ? 'close' : 'arrow-left'"
    @action="removeItem"
    @dismiss="back.name ?
      $router.push(back).catch(() => {}) :
      $_octPrototypeView_goBack()"
  >
    <!-- Content -->
    <div class="ss-treatment__content" v-if="item">
      <!-- Customer. Customer may not exist -->
      <oct-customer-card
        :icon="customer && customer.profileIcon || undefined"
        :title="customer ? `${customer.name} 様` : ''"
        :text="`来店日時：${$_octPrototypeView_getDateString(item.publishedAt, true)}〜`"
        :meta="{
          text: item.status >= 4 ? '送信済' : '未送信',
          active: item.status < 4
        }"
        history
        @click:history="customer && $router.push({
          name: 'Customer',
          params: {
            customerId: customer.id
          }
        })"
        class="ss-treatment-intro"
      />

      <!-- Stylists -->
      <div class="ss-treatment__section ss-treatment__section--user">
        <div
          class="ss-treatment-header"
          :class="{
            'ss-treatment-header--empty': !item.stylists.length
          }"
        >
          <h3 class="ss-treatment-header__primary-text">
            <span class="ss-treatment-header__icon">
              <oct-icon icon="done"/>
            </span>
            スタイリスト
          </h3>
        </div>

        <oct-list>
          <!-- The user may not exist -->
          <oct-list-item
            v-for="item in staffs(item.stylists)"
            :key="item.id"
            :media="{
              image: $_octPrototypeView_getProfileIconSafely(item.profileIcon)
            }"
            :title="`${item.lastName || ''} ${item.firstName || ''}`"
            text="スタイリスト"
            removable
            @remove="removeUser('stylists', item.id)"
            @click.native="$router.push({
              path: `${$route.path}/stylists`
            }).catch(() => {})"
          >
            <template #trailing-icon>
              <oct-icon icon="chevron-right"/>
            </template>
          </oct-list-item>

          <oct-list-item
            :media="{
              image: $_octPrototypeView_getProfileIconSafely()
            }"
            title="スタイリストを追加"
            @click.native="$router.push({
              path: `${$route.path}/stylists`
            }).catch(() => {})"
          >
            <template #trailing-icon>
              <oct-icon icon="chevron-right"/>
            </template>
          </oct-list-item>
        </oct-list>
      </div>

      <!-- Assistants -->
      <div class="ss-treatment__section ss-treatment__section--user">
        <div
          class="ss-treatment-header"
          :class="{
            'ss-treatment-header--empty': !item.assistants.length
          }"
        >
          <h3 class="ss-treatment-header__primary-text">
            <span class="ss-treatment-header__icon">
              <oct-icon icon="done"/>
            </span>
            アシスタント
          </h3>
        </div>

        <oct-list>
          <!-- The user may not exist -->
          <oct-list-item
            v-for="item in staffs(item.assistants)"
            :key="item.id"
            :media="{
              image: $_octPrototypeView_getProfileIconSafely(item.profileIcon)
            }"
            :title="`${item.lastName || ''} ${item.firstName || ''}`"
            text="アシスタント"
            removable
            @remove="removeUser('assistants', item.id)"
            @click.native="$router.push({
              path: `${$route.path}/assistants`
            }).catch(() => {})"
          >
            <template #trailing-icon>
              <oct-icon icon="chevron-right"/>
            </template>
          </oct-list-item>

          <oct-list-item
            :media="{
              image: $_octPrototypeView_getProfileIconSafely()
            }"
            title="アシスタントを追加"
            @click.native="$router.push({
              path: `${$route.path}/assistants`
            }).catch(() => {})"
          >
            <template #trailing-icon>
              <oct-icon icon="chevron-right"/>
            </template>
          </oct-list-item>
        </oct-list>
      </div>

      <!-- Products -->
      <div class="ss-treatment__section">
        <div
          class="ss-treatment-header"
          :class="{
            'ss-treatment-header--empty': !item.shampoo && !item.treatment && !item.outbath && !item.others.length
          }"
        >
          <h3 class="ss-treatment-header__primary-text">
            <span class="ss-treatment-header__icon">
              <oct-icon icon="done"/>
            </span>
            使用商品
          </h3>
        </div>

        <oct-list>
          <!-- Shampoo -->
          <oct-list-item
            v-bind="product(item.shampoo, 1)"
            :removable="!!productByID(item.shampoo)"
            @remove="removeProduct('shampoo')"
            @click.native="$router.push({
              path: `${$route.path}/products/categories/1`,
              query: {
                prop: 'shampoo'
              }
            })"
          >
            <template #trailing-icon>
              <oct-icon icon="chevron-right"/>
            </template>
          </oct-list-item>

          <!-- Treatment -->
          <oct-list-item
            v-bind="product(item.treatment, 2)"
            :removable="!!productByID(item.treatment)"
            @remove="removeProduct('treatment')"
            @click.native="$router.push({
              path: `${$route.path}/products/categories/2`,
              query: {
                prop: 'treatment'
              }
            })"
          >
            <template #trailing-icon>
              <oct-icon icon="chevron-right"/>
            </template>
          </oct-list-item>

          <!-- Out bath -->
          <oct-list-item
            v-bind="product(item.outbath, 3)"
            :removable="!!productByID(item.outbath)"
            @remove="removeProduct('outbath')"
            @click.native="$router.push({
              path: `${$route.path}/products/categories/3`,
              query: {
                prop: 'outbath'
              }
            })"
          >
            <template #trailing-icon>
              <oct-icon icon="chevron-right"/>
            </template>
          </oct-list-item>

          <!-- Others -->
          <oct-list-item
            v-for="(p, j) in others"
            :key="p"
            v-bind="product(p, 4)"
            removable
            @remove="removeProduct('others',p)"
            @click.native="$router.push({
              path: `${$route.path}/products/categories`,
              query: {
                prop: 'others',
                index: j
              }
            })"
          >
            <template #trailing-icon>
              <oct-icon icon="chevron-right"/>
            </template>
          </oct-list-item>

          <!-- Others plus -->
          <oct-list-item
            title="その他"
            icon="plus-circle"
            @click.native="$router.push({
              path: `${$route.path}/products/categories`,
              query: {
                prop: 'others',
                index: -1
              }
            })"
          >
            <template #trailing-icon>
              <oct-icon icon="chevron-right"/>
            </template>
          </oct-list-item>
        </oct-list>
      </div>

      <!-- Recommend Product -->
      <div class="ss-treatment__section">
        <div
          class="ss-treatment-header"
          :class="{
            'ss-treatment-header--empty': !item.data.recommendedItem.item
          }"
        >
          <h3 class="ss-treatment-header__primary-text">
            <span class="ss-treatment-header__icon">
              <oct-icon icon="done"/>
            </span>
            おすすめ商品
          </h3>
        </div>

        <oct-list>
          <!-- Product -->
          <oct-list-item
            title="商品を選ぶ"
            icon="plus-circle"
            @click.native="$router.push({
              path: `${$route.path}/products/categories`,
              query: {
                prop: 'recommended',
              }
            })"
            v-if="!item.data.recommendedItem.item || !this.$store.getters['products/byId'](item.data.recommendedItem.item)"
          >
            <template #trailing-icon>
              <oct-icon icon="chevron-right"/>
            </template>
          </oct-list-item>

          <oct-list-item
            v-bind="this.product(item.data.recommendedItem.item)"
            removable
            @remove="removeProduct('recommended',p)"
            @click.native="$router.push({
              path: `${$route.path}/products/categories`,
              query: {
                prop: 'recommended',
              }
            })"
            v-else
          >
            <template #trailing-icon>
              <oct-icon icon="chevron-right"/>
            </template>
          </oct-list-item>
        </oct-list>
      </div>

      <!-- Message for Recommend Product -->
      <div
        class="ss-treatment__section"
        v-if="$_ssTreatmentView_recommendedMessage"
      >
        <div
          class="ss-treatment-header"
          :class="{
            'ss-treatment-header--empty': !item.data.recommendedItem.message
          }"
        >
          <h3 class="ss-treatment-header__primary-text">
            <span class="ss-treatment-header__icon">
              <oct-icon icon="done"/>
            </span>
            おすすめ商品メッセージ
          </h3>
        </div>

        <div class="ss-treatment__body">
          <oct-text-field
            :rows="7"
            v-model="$_ssTreatmentView_recommendedMessage"
            block
            disabled
          >
            <template #helperText>
              仕様変更に伴い、現在お客様には表示されておりません
            </template>
          </oct-text-field>
        </div>
      </div>

      <!-- Photos -->
      <div class="ss-treatment__section">
        <div
          class="ss-treatment-header"
          :class="{
            'ss-treatment-header--empty': !$data.$_ssTreatmentView_localImages.some(i => i.id)
          }"
        >
          <h3 class="ss-treatment-header__primary-text">
            <span class="ss-treatment-header__icon">
              <oct-icon icon="done"/>
            </span>
            施術写真
          </h3>
        </div>

        <div class="ss-treatment-slider">
          <ul class="ss-treatment-media">
            <li
              class="ss-treatment-media__item"
              v-for="(img, i) in this.$data.$_ssTreatmentView_localImages"
              :key="`p${i}`"
            >
              <oct-media
                :image="img"
                :actions="['remove', 'zoom']"
                editable
                @remove="removeImage(i)"
                @upload:complete="$_ssTreatmentView_onUploadStatusChange($event, i)"
                @click:media="$_ssTreatmentView_onClickImage(i)"
                ref="ssTreatmentView__images"
                v-if="img.id"
              />

              <oct-media
                :image="$_ssTreatmentView_image(i%3+1)"
                :actions="['add']"
                :file="img.file || undefined"
                editable
                multiple
                @upload:complete="$_ssTreatmentView_onUploadStatusChange($event, i)"
                @upload:multiple="$_ssTreatmentView_onUploadMultipleFiles"
                ref="ssTreatmentView__images"
                v-else
              />
            </li>

            <li
              class="ss-treatment-media__item"
              :key="`p${this.$data.$_ssTreatmentView_localImages.length}`"
            >
              <oct-media
                :actions="['new']"
                editable
                multiple
                @upload:complete="$_ssTreatmentView_onUploadStatusChange"
                @upload:multiple="$_ssTreatmentView_onUploadMultipleFiles"
              />
            </li>

            <li class="ss-treatment-media__item" role="separator"></li>
          </ul>
        </div>

        <!-- Note -->
        <div class="ss-treatment__note">
          <p class="ss-treatment__note-text">
            ※ブラウザ上で撮影するとカメラロールに写真が保存されません。
          </p>
        </div>
      </div>

      <!-- Video -->
      <div class="ss-treatment__section">
        <div
          class="ss-treatment-header"
          :class="{
            'ss-treatment-header--empty': !item.videos.length
          }"
        >
          <h3 class="ss-treatment-header__primary-text">
            <span class="ss-treatment-header__icon">
              <oct-icon icon="done"/>
            </span>
            施術動画
          </h3>
        </div>

        <div class="ss-treatment-media ss-treatment-media--video">
          <oct-media
            type="video"
            :video.sync="$_ssTreatmentView_video"
            :actions="$_ssTreatmentView_video ? ['remove'] : ['add']"
            @remove="removeVideo"
            editable
          />
        </div>

        <!-- Note -->
        <div class="ss-treatment__note">
          <p class="ss-treatment__note-text">
            ※ブラウザ上で撮影するとカメラロールに写真が保存されません。
          </p>
        </div>
      </div>

      <!-- Message -->
      <div class="ss-treatment__section">
        <div
          class="ss-treatment-header"
          :class="{
            'ss-treatment-header--empty': !item.message
          }"
        >
          <h3 class="ss-treatment-header__primary-text">
            <span class="ss-treatment-header__icon">
              <oct-icon icon="done"/>
            </span>
            一言コメント
          </h3>
        </div>

        <div class="ss-treatment__body">
          <oct-text-field
            :rows="7"
            v-model="$_ssTreatmentView_message"
            block
          ></oct-text-field>
        </div>
      </div>

      <!-- Menus -->
      <div class="ss-treatment__section">
        <div
          class="ss-treatment-header"
          :class="{
            'ss-treatment-header--empty': !item.menus.length
          }"
        >
          <h3 class="ss-treatment-header__primary-text">
            <span class="ss-treatment-header__icon">
              <oct-icon icon="done"/>
            </span>
            施術メニュー
          </h3>
        </div>

        <div class="ss-treatment__body">
          <ul class="ss-treatment-menu-list">
            <li
              v-for="menu in $store.state.menus"
              :key="menu.id"
              class="ss-treatment-menu-list__item"
            >
              <label class="ss-treatment-menu-list__content">
                <oct-checkbox :value="menu.id" v-model="$_ssTreatmentView_menus" />

                <span class="ss-treatment-menu-list__text">
                  {{ menu.title }}
                </span>
              </label>
            </li>
          </ul>
        </div>
      </div>

      <!-- Reservation Date -->
      <div
        class="ss-treatment__section"
        v-if="$store.getters.hasBetaAccess"
      >
        <div
          class="ss-treatment-header"
          :class="{
            'ss-treatment-header--empty': !$_ssTreatmentView_isReservationDateValid
          }"
        >
          <h3 class="ss-treatment-header__primary-text">
            <span class="ss-treatment-header__icon">
              <oct-icon icon="done"/>
            </span>

            次回来店目安
          </h3>
        </div>

        <div class="ss-treatment__body ss-treatment-reservation-date__content">
          <!-- Date Setting -->
          <div class="ss-treatment-reservation-date__setting">
            <label class="ss-treatment-menu-list__content">
              <oct-checkbox
                v-model="$_ssTreatmentView_shouldSendNotification"
                :disabled="!$_ssTreatmentView_canSetReservationDate"
              />

              <span class="ss-treatment-menu-list__text">
                通知を送る
              </span>
            </label>

            <!-- Selection -->
            <div class="ss-treatment-reservation-date__selection">
              <!-- Year -->
              <oct-select
                :items="[
                  {
                    value: null,
                    text: '年'
                  }
                ].concat(Array(2).fill(0).map((val, i) => (
                  {
                    value: new Date().getFullYear() + i,
                    text: new Date().getFullYear() + i
                  }
                )))"
                v-model="$data.$_ssTreatmentView_reservationDate.year"
                :disabled="!$_ssTreatmentView_canSetReservationDate || !$_ssTreatmentView_shouldSendNotification"
                outline
              />

              <!-- Month -->
              <oct-select
                :items="[
                  {
                    value: null,
                    text: '月'
                  }
                ].concat(Array(12).fill(0).map((val, i) => (
                  {
                    value: String(i + 1).padStart(2, '0'),
                    text: i + 1
                  }
                )))"
                v-model="$data.$_ssTreatmentView_reservationDate.month"
                :disabled="!$_ssTreatmentView_canSetReservationDate || !$_ssTreatmentView_shouldSendNotification"
                outline
              />

              <!-- Period -->
              <oct-select
                :items="[
                  {
                    value: null,
                    text: '時期'
                  },
                  {
                    value: '01',
                    text: '上旬'
                  },
                  {
                    value: '10',
                    text: '中旬'
                  },
                  {
                    value: '20',
                    text: '下旬'
                  },
                ]"
                v-model="$data.$_ssTreatmentView_reservationDate.day"
                :disabled="!$_ssTreatmentView_canSetReservationDate || !$_ssTreatmentView_shouldSendNotification"
                outline
              />
            </div>

            <!-- Note -->
            <p class="ss-treatment__note-text">
              ※一度送信すると変更できません。
            </p>
          </div>
          
          <!-- Reservation URL -->
          <div class="ss-treatment-reservation-date__url">
            <h4 class="ss-treatment__input-label">
              予約URL
            </h4>

            <oct-text-field
              :value="$store.state.reservationUrl"
              block
              disabled
            />

            <!-- Note -->
            <div class="ss-treatment__note">
              <p class="ss-treatment__note-text">
                ※予約URLはオーナー管理画面からのみ登録および変更可能です。
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Note -->
      <div class="ss-treatment__section ss-treatment__section--note">
        <!-- Memo -->
        <div class="ss-treatment__section">
          <div class="ss-treatment-header">
            <h3 class="ss-treatment-header__primary-text">
              施術メモ
            </h3>
          </div>

          <div class="ss-treatment__body">
            <oct-text-field
              :rows="7"
              :maxlength="800"
              v-model="$_ssTreatmentView_memo"
              block
            >
              <template #helperText>
                ※お客様には表示されません。
              </template>
            </oct-text-field>
          </div>
        </div>

        <!-- Action for Viewer -->
        <div class="ss-treatment__section">
          <div class="ss-treatment-header">
            <h3 class="ss-treatment-header__primary-text">
              ビューワー連携
            </h3>
          </div>

          <div class="ss-treatment__body ss-treatment-action">
            <oct-button
              block
              outline
              size="large"
              :disabled="item.status >= 3"
              class="ss-treatment__action"
              @click.native="updateState(3)"
            >
              ビューワー連携
            </oct-button>

            <!-- Note -->
            <p class="ss-treatment-action__caption">
              ※保存されている最新スタイルが連携されます。
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Email to send -->
    <ss-customer-mail
      :id="item.id"
      ref="$_ssTV_email"
      class="ss-treatment__customer-email"
      v-if="item"
    />

    <!-- Child routes -->
    <transition :name="transitionName">
      <router-view class="ss-dialog__content" :key="$route.name"/>
    </transition>

    <transition name="fade" appear>
      <div
        class="ss-treatment-lightbox"
        v-show="$data.$_ssTreatmentView_lightbox"
      >
        <!-- Close Icon -->
        <oct-icon
          icon="close"
          class="ss-treatment-lightbox__close"
          @click.native="$data.$_ssTreatmentView_lightbox = false"
        />

        <!-- Carousel -->
        <swiper
          :options="$data.$_ssTreatmentView_swiperOptions"
          @slide-change="$data.$_ssTreatmentView_lightbox_index = $refs.$_ssTreatmentView_swiper.$swiper.realIndex"
          ref="$_ssTreatmentView_swiper"
        >
          <swiper-slide
            v-for="item in $data.$_ssTreatmentView_localImages.filter(i => i.id)"
            :key="item.id"
          >
            <div class="ss-treatment-lightbox__media">
              <oct-media
                :image="item"
              />
            </div>
          </swiper-slide>
        </swiper>

        <!-- Thumbnails -->
        <ol class="ss-treatment-lightbox-thumbs">
          <li
            class="ss-treatment-lightbox-thumbs__item"
            :class="{
              'ss-treatment-lightbox-thumbs__item--active': i === $data.$_ssTreatmentView_lightbox_index
            }"
            v-for="(item, i) in $data.$_ssTreatmentView_localImages.filter(i => i.id)"
            :key="item.id"
          >
            <oct-media
              :image="item"
              @click.native="$_ssTreatmentView_lightboxSlideTo(i)"
            />
          </li>
        </ol>
      </div>
    </transition>

    <template
      #actions
      v-if="
        item &&
        (
          $store.state.staffs.me.isAdministrator ||
          $store.state.staffs.me.role === 1 ||
          item.status < 4 ||
          (new Date).getTime() - item.publishedAt.getTime() < 48*3600*1000
        )
      "
    >
      <!-- Save -->
      <div class="ss-treatment-action">
        <oct-button
          block
          outline
          size="large"
          :disabled="item.status >= 3"
          class="ss-treatment__action"
          @click.native="save"
        >
          保存
        </oct-button>

        <span class="ss-treatment-action__caption">
          {{
            item.updatedAt.toLocaleString('ja-JP', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit',
            })
          }}に保存
        </span>
      </div>

      <!-- Send -->
      <div class="ss-treatment-action">
        <oct-button
          size="large"
          @click.native="updateState(4)"
          class="ss-treatment__action"
        >
          {{ item.status >= 4 ? '更新' : '送信' }}
        </oct-button>

        <span class="ss-treatment-action__caption">
          {{
            item.data && item.data.releasedAt ?
              new Date(item.data.releasedAt).toLocaleString('ja-JP', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
              }) + 'に送信'
              : '&nbsp;'
          }}
        </span>
      </div>
    </template>
  </oct-dialog>
</template>

<script>
import _isEqual from 'lodash/isEqual'
import _cloneDeep from 'lodash/cloneDeep'
import API from '@/api/index.js'
import OctIcon from '@/components/icon/OctIcon.vue'
import OctButton from '@/components/button/OctButton.vue'
import OctCheckbox from '@/components/checkbox/OctCheckbox.vue'
import OctSelect from '@/components/select/OctSelect.vue'
import OctMedia from '@/components/media/OctMedia.vue'
import OctTextField from '@/components/text-field/OctTextField.vue'
import OctList from '@/components/list/OctList.vue'
import OctListItem from '@/components/list/OctListItem.vue'
import OctDialog from '@/components/dialog/OctDialog.vue'
import OctCustomerCard from '@/components/customer-card/OctCustomerCard.vue'
import OctPrototypeView from '@/mixins/OctPrototypeView.js'
import SsCustomerMail from '@/views/SSCustomerMail.vue'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'

export default {
  name: 'SSTreatmentView',
  mixins: [
    OctPrototypeView
  ],
  components: {
    OctIcon,
    OctButton,
    OctCheckbox,
    OctSelect,
    OctMedia,
    OctTextField,
    OctList,
    OctListItem,
    OctDialog,
    OctCustomerCard,
    SsCustomerMail,
    Swiper,
    SwiperSlide
  },
  props: {
    /** Treatment ID */
    treatmentId: {
      type: String,
      default: ''
    },
    /** Indicate editable */
    editable: {
      type: Boolean,
      default: true
    },
    /** Path to go back */
    back: {
      type: Object,
      default: () => ({})
    },
  },
  data: () => ({
    /** Local images */
    $_ssTreatmentView_localImages: [],
    /** Swiper options */
    $_ssTreatmentView_swiperOptions: {
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }
    },
    /** Indicate show lightbox */
    $_ssTreatmentView_lightbox: false,
    /** Index position of the current image in the lightbox */
    $_ssTreatmentView_lightbox_index: 0,
    /** Indicate enable notification */
    $_ssTreatmentView_enableNotification: false,
    /** Reservation date view model */
    $_ssTreatmentView_reservationDate: {
      year: null,
      month: null,
      day: null,
    },
  }),
  computed: {
    /** Treatment data */
    item: vm => vm.$store.getters['treatments/byId'](vm.treatmentId),
    /** Customer data */
    customer: vm => vm.item ? vm.$store.getters['customers/byId'](vm.item.customer) : undefined,
    /** @returns {array} Array of actual staff data */
    staffs: vm => items => items.reduce((acc, cur) => acc.concat(vm.$store.getters['staffs/byId'](cur.id) || []), []),
    /** Produc by ID */
    productByID: vm => id => vm.$store.getters['products/byId'](id),
    /** Other products */
    others: vm => vm.item.others.filter(item => vm.$store.getters['products/byId'](item)),
    /** Message for recommended item */
    $_ssTreatmentView_recommendedMessage: {
      get () {
        return this.item.data.recommendedItem.message
      },
      set (val) {
        this.$store.dispatch('treatments/set', {
          items: [{
            id: this.item.id,
            data: {
              recommendedItem: {
                message: val
              }
            }
          }]
        })
      }
    },
    /** Message from the stylist */
    $_ssTreatmentView_message: {
      get () {
        return this.item.message
      },
      set (val) {
        this.$store.dispatch('treatments/set', {
          items: [{
            id: this.item.id,
            message: val
          }]
        })
      }
    },
    /** Image to newly upload */
    $_ssTreatmentView_image: () => (i=1) => (
      {
        id: '',
        lowResolution: `/images/styling__alt--0${i}.png`,
        standardResolution: `/images/styling__alt--0${i}.png`,
        highResolution: `/images/styling__alt--0${i}.png`,
        status: 1
      }
    ),
    /** Treatment’s videos */
    $_ssTreatmentView_video: {
      get () {
        return this.item.videos[0]
      },
      set (val) {
        this.$store.dispatch('treatments/set', {
          items: [{
            id: this.item.id,
            videos:[val]
          }]
        })
      }
    },
    /** Treatment menus */
    $_ssTreatmentView_menus: {
      get () {
        return this.item.menus.map(item => item.id) || []
      },
      set (val) {
        this.$store.dispatch('treatments/set', {
          items: [{
            id: this.item.id,
            menus: val && Array.isArray(val) ? val.map(item => ({id: item})) : []
          }]
        })
      }
    },
    /** Treatment Momo */
    $_ssTreatmentView_memo: {
      get () {
        return this.item.data.memo
      },
      set (val) {
        this.$store.dispatch('treatments/set', {
          items: [{
            id: this.item.id,
            data: Object.assign(this.item.data, {
              memo: val
            })
          }]
        })
      }
    },
    /**
     * Whether to send a customer notification from this screen (two-way, local UI).
     * Getter/setter mirror `$data.$_ssTreatmentView_enableNotification`.
     * Assigning a falsy value also resets `$data.$_ssTreatmentView_reservationDate`
     * (`year`, `month`, `day` to `null`).
     * @type {boolean}
     */
    $_ssTreatmentView_shouldSendNotification: {
      get () {
        return this.$data.$_ssTreatmentView_enableNotification
      },
      set (val) {
        if (!val)
          this.$data.$_ssTreatmentView_reservationDate = {
            year: null,
            month: null,
            day: null,
          }

        this.$data.$_ssTreatmentView_enableNotification = val
      }
    },
    /** Indicate can set reservation date */
    $_ssTreatmentView_canSetReservationDate: {
      get: vm => vm.item.status < 4
    },
    /** Indicate if the reservation date is valid */
    $_ssTreatmentView_isReservationDateValid: {
      get () {
        return this.$data.$_ssTreatmentView_reservationDate.year &&
          this.$data.$_ssTreatmentView_reservationDate.month &&
          this.$data.$_ssTreatmentView_reservationDate.day
      }
    }
  },
  methods: {
    /** Product by ID */
    product (id='', alt='') {
      return this.productToListItem(
        // The product may be discontinued
        id && this.$store.getters['products/byId'](id) ?
          this.$store.getters['products/byId'](id) :
          {
            categories: [{
              id: alt,
              name: this.$store.getters['products/categoryById'](alt).name
            }]
          }
      )
    },
    /** Remove this item */
    async removeItem () {
      try {
        // Confirm 
        await this.$store.dispatch('confirm', 'この施術情報を本当に削除しますか？削除すると元には戻せません。')

        // Do remove
        this.$store.dispatch('treatments/remove', {items:[this.item]})
          .then(() => {
            this.$_octPrototypeView_goBack()
            // Notify
            this.$store.dispatch('notify', {text: '施術情報を削除しました', type: 'danger'})
          })
          .catch(thrown => this.$store.commit('error', thrown))
      } catch {
        // Do nothing
      }
    },
    /** Remove a user from this item */
    removeUser (type, id) {
      this.$store.dispatch('treatments/set', {
        items: [{
          id: this.item.id,
          [type]: this.item[type].filter(i => i.id !== id),
        }]
      })
    },
    /** Remove a product from this item */
    removeProduct (type, id=null) {
      // Case of recommended item
      if (type === 'recommended') {
        this.$store.dispatch('treatments/set', {
          items: [{
            id: this.item.id,
            data: {
              recommendedItem: {
                item: ''
              }
            },
          }]
        })

        return
      }

      id === null ?
        this.$store.dispatch('treatments/set', {
          items: [{
            id: this.item.id,
            [type]: '',
          }]
        }) :
        this.$store.dispatch('treatments/set', {
          items: [{
            id: this.item.id,
            [type]: this.item[type].filter((i) => i !== id),
          }]
        })
    },
    /** Update state */
    async updateState (val) {
      if (!this.$store.state.isOnline)
        return this.$store.dispatch('alert', '現在オフラインの為、保存できません。')

      try {
        // Item data field
        const data = this.item.data
        const oldData = _cloneDeep({releasedAt: null}, data)
        // Current status
        const oldStatus = this.item.status

        // Confirm 
        this.item.status !== 4 ?
          await this.$store.dispatch('confirm', `この施術情報を${val === 3 ? 'タブレット' : 'milbon:iD'}に連携しますか？この操作は元に戻せません。`) :
          await this.$store.dispatch('confirm', 'この施術情報を更新しますか？ただし、既に送付したメールの内容は変更できません。')

        // Set reservation date
        this.$_ssTreatmentView_setReservationDate()

        // The first publishing
        // Add overdue state and release time
        if (val === 4 && this.item.status !== 4) {
          // Update overdue property (Sent within 72hours)
          data.overdue = new Date().getTime() - this.item.publishedAt.getTime() > 72*3600*1000
          data.releasedAt = new Date()
        }

        // Sync images
        this.$_ssTreatmentView_syncImages()

        // Actually update
        this.$store.commit('treatments/add', {
          items: [{
            id: this.item.id,
            status: val,
            data: data
          }],
          clean: true
        })

        // Do save
        this.$store.dispatch('treatments/save', {id: this.item.id}).then(() => {
          val === 4 && oldStatus !== 4 && this.customer.email_opted_in &&
            // Send mail
            API.sendEmail(
              [this.customer.email],
              'STYLE STOCKに新しいスタイルが追加されました',
              this.$refs.$_ssTV_email.toHTML()
            )
              .catch(() => this.$store.commit('error', {message: 'お客さまにメールが送信できませんでした'}))

          // Notify
          this.$store.dispatch('notify', {text: val === 3 ? 'タブレットに連携しました' : 'milbon:iDに送信しました'})

          // Store current data as fetched data
          this.item.fetchedData = _cloneDeep(this.item)

          // Go to ‘Dashboard’
          oldStatus !== 4 && val === 4 && this.$router.push({name:'Dashboard'}).catch(() => {})
        })
          .catch(() => {
            // Revert changes
            this.$store.commit('treatments/add', {
              items: [{
                id: this.item.id,
                status: oldStatus,
                data: oldData
              }],
              clean: true
            })

            this.$store.dispatch('alert', `施術情報の保存に失敗しました。再度保存してください。`)
          })
      } catch {/* Do noting */}
    },
    async save () {
      if (!this.$store.state.isOnline)
        return this.$store.dispatch('alert', '現在オフラインの為、保存できません。')

      try {
        // Sync images
        this.$_ssTreatmentView_syncImages()

        // Set reservation date
        this.$_ssTreatmentView_setReservationDate()

        // Do save
        await this.$store.dispatch('treatments/save', {
          id: this.item.id
        })

        // Store current data as fetched data
        this.item.fetchedData = _cloneDeep(this.item)

        // Notify
        this.$store.dispatch('notify', {text: '施術情報を保存しました。'})
      }
      catch (thrown) {
        if (thrown && typeof thrown === 'object')
          thrown.message = '施術情報の保存に失敗しました。再度保存してください。'

        this.$store.commit('error', thrown)
      }
    },
    /** Remove an image */
    async removeImage (index) {
      try {
        // Confirm
        await this.$store.dispatch('confirm', {text: 'この写真を本当に削除しますか？\n削除すると元には戻せません。'})

        // Remove an item
        this.$set(this.$data.$_ssTreatmentView_localImages, index, {})
      } catch {() => {}}
    },
    /** Sync image to the store */
    $_ssTreatmentView_syncImages (pack=true) {
        if (!this.item) return

        this.$store.commit('treatments/add', {
          items: [{
            id: this.item.id,
            images: pack ? this.$data.$_ssTreatmentView_localImages.filter(i => i.id) : this.$data.$_ssTreatmentView_localImages,
          }],
          clean: true
        })
    },
    /** Remove an video */
    async removeVideo () {
      try {
        // Confirm
        await this.$store.dispatch('confirm', {text: 'この動画を本当に削除しますか？\n削除すると元には戻せません。'})

        // Remove an video
        this.$store.dispatch('treatments/set', {
          items: [{
            id: this.item.id,
            videos: []
          }]
        })
      } catch {() => {}}
    },
    async $_ssTreatmentView_onUploadMultipleFiles (files=[]) {
      if (!files.length) return

      const emptyImages = this.$refs.ssTreatmentView__images.filter(item => !item.processing && !item.image.id)

      // Add empty images if needed
      if (emptyImages.length < files.length)
        this.$data.$_ssTreatmentView_localImages.push(...Array(files.length-emptyImages.length).fill({}))

      // Wait for the DOM to be updated
      await this.$nextTick()

      // Append files to the exsting local images
      this.$refs.ssTreatmentView__images && this.$refs.ssTreatmentView__images.forEach(item => {
        if (files.length && !item.processing && !item.image.id)
          item.uploadMedia(files.shift())
      })
    },
    /** Image upload status change handler */
    async $_ssTreatmentView_onUploadStatusChange (image, i=null) {
      i !== null ? this.$set(this.$data.$_ssTreatmentView_localImages, i, image)
        : this.$data.$_ssTreatmentView_localImages.push(image)

      this.$_ssTreatmentView_syncImages(false)
    },
    $_ssTreatmentView_setReservationDate () {
      this.$store.dispatch('treatments/set', {
        items: [{
          id: this.item.id,
          reservationDate: this.$_ssTreatmentView_isReservationDateValid
            ? [
                this.$data.$_ssTreatmentView_reservationDate.year,
                this.$data.$_ssTreatmentView_reservationDate.month,
                this.$data.$_ssTreatmentView_reservationDate.day
              ].join('-')
            : null,
        }]
      })
    },
    /** Slide carousel */
    $_ssTreatmentView_lightboxSlideTo (index) {
      this.$refs.$_ssTreatmentView_swiper.$swiper.slideTo(index)
    },
    /**
     * Image click handler
     * @param {number} i - Image index initially shown
     */
    $_ssTreatmentView_onClickImage (i) {
      this.$data.$_ssTreatmentView_lightbox = true
      this.$refs.$_ssTreatmentView_swiper.$swiper.slideTo(i)
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // Reset scroll position if final destination is this component
      if (to.matched[to.matched.length-1].instances &&
            to.matched[to.matched.length-1].instances.default === vm)
        to.meta.savedPosition = {top: 0, treatmentId: ''}
    })
  },
  beforeRouteUpdate (to, from, next) {
    // If leave from this component, save scroll position and current treatment ID to from route meta field 
    if (from.matched[from.matched.length-1].instances &&
          from.matched[from.matched.length-1].instances.default === this)
      from.meta.savedPosition = {top: this.$el.scrollTop, treatmentId: from.params.treatmentId}

    next()
  },
  async beforeRouteLeave (to, from, next) {
    const currentRouteMatched = this.$route.matched

    // Do nothing if from is child root
    if (
      from.matched.length > currentRouteMatched.length &&
      currentRouteMatched.every((r, i) => r.path === from.matched[i].path)
    )
      return next()

    // Sync images
    this.$_ssTreatmentView_syncImages()

    // Strip unnecessary data to compare
    const normalize = item => Object.assign({}, item, {publishedAt: null, fetchedData: null, updatedAt: null})

    // If the item is not saved, show confirm dialog
    if (
      this.item &&
      !_isEqual(
        normalize(this.item.fetchedData),
        normalize(this.item)
      )
    ) 
      try {
        await this.$store.dispatch('confirm', 'この施術情報は保存前です。ページを移動してよろしいですか？')
      } catch {
        return false
      }

    next()
  },
  mounted () {
    // Restore scroll position if saved treatment ID had not changed
    this.$el.scrollTo(0, this.$route.meta.savedPosition &&
      this.$route.meta.savedPosition.treatmentId === this.$route.params.treatmentId &&
        this.$route.meta.savedPosition.top || 0)
  },
  watch: {
    /** Initialize reservation date */
    'item.reservationDate': {
      handler (val) {
        // Reset notification flag
        this.$data.$_ssTreatmentView_enableNotification = false

        // Reset reservation date view model
        this.$data.$_ssTreatmentView_reservationDate = {
          year: null,
          month: null,
          day: null,
        }

        if (!val) return

        const reservationDate = new Date(val)

        if (!Number.isNaN(reservationDate.getFullYear())) {
          this.$data.$_ssTreatmentView_reservationDate = {
            year: reservationDate.getFullYear(),
            month: String(reservationDate.getMonth() + 1).padStart(2, '0'),
            day: String(reservationDate.getDate()).padStart(2, '0'),
          }

          this.$data.$_ssTreatmentView_enableNotification = true
        }
      },
      immediate: true,
    },
    'item.images': {
      handler (val=[]) {
        this.$data.$_ssTreatmentView_localImages = val.concat(val.length < 3 ? Array(3-val.length).fill({}) : [])
      },
      immediate: true,
    }
  }
}
</script>

<style scoped lang="scss">
@import "../components/theme/variables";
@import "../components/grid/variables";
@import "../components/typography/variables";
@import "../components/typography/mixins";
@import "../../node_modules/swiper/css/swiper.css";

.ss-treatment__content {
@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  margin-bottom: oct-rem(64);
}
}

.ss-treatment-intro {
  margin: 0 0 oct-rem(64);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: oct-rem(32) oct-rem(16) 0;

  .oct-chip {
    margin-bottom: oct-rem(16);
  }

@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  padding: 0 oct-rem(64);
}
}

.ss-treatment-intro__media {
  margin: 0 0 oct-rem(16);
  width: oct-rem(80);
  height: oct-rem(80);
}

.ss-treatment-intro__image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.ss-treatment-intro__text {
  text-align: center;
}

.ss-treatment-intro__primary-text {
  font-size: oct-rem(32);
  font-weight: bold;
  line-height: 1;
  margin: 0 0 oct-rem(16)
}

.ss-treatment-intro__secondary-text {
  font-size: oct-rem(12);
  line-height: 1;
  color: #928F9B;
  margin: 0 0 oct-rem(16);
  display: block;
}

.ss-treatment-intro__link-text {
  font-size: oct-rem(16);
  line-height: 1;
  color: $oct-theme--primary;
  fill: $oct-theme--primary;
  display: inline-flex;
  align-items: center;

  .oct-icon {
    margin-left: oct-rem(4);
    width: oct-rem(20);
    height: oct-rem(20);
  }
}

.ss-treatment__section {
  margin: 0 0 oct-rem(64);

  &--note {
    display: flex;
    flex-direction: column;
    margin: 0 oct-rem(-16);
    padding: oct-rem(64) oct-rem(16) 0;
    background-color: $oct-theme--neutral-10;
  }

@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  &--user {
    &::v-deep .oct-list__content {
      display: grid;
      grid-template-columns: 50% 50%;
    }
  }

  &--note {
    margin: 0 oct-rem(-64);
    padding: oct-rem(64) oct-rem(64) 0;
    background-color: $oct-theme--neutral-10;
  }
}
}

.ss-treatment-header {
  margin: 0 0 oct-rem(16);
  padding: 0;

@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  margin-bottom: oct-rem(32);
}
}

.ss-treatment-header__primary-text {
  font-size: oct-rem(20);
  line-height: 1;
  display: flex;
  align-items: center;

@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  font-size: oct-rem(24);
}
}

.ss-treatment-header__icon {
  fill: $oct-theme--on-primary;
  color: $oct-theme--on-primary;
  margin: 0 oct-rem(8) 0 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: oct-rem(32);
  height: oct-rem(32);
  border-radius: 50%;
  background-color: $oct-theme--primary;

  .ss-treatment-header--empty & {
    background-color: $oct-theme--neutral-20;
  }

  .oct-icon {
    width: 100%;
    height: 100%;
  }
}

.ss-treatment__input-label {
  font-size: oct-rem(16);
  font-weight: 600;
  line-height: 1;
  color: $oct-theme--neutral-50;
  margin: 0 0 oct-rem(8);
}

.ss-treatment-slider {
  margin: 0 oct-rem(-16) oct-rem(-16);
  padding: 0 0 oct-rem(16);
  overflow: auto;

@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  margin: 0 oct-rem(-64) oct-rem(-16);
  padding: 0 0 oct-rem(16);
}
}

.ss-treatment-media {
  margin: 0;
  display: flex;
  gap: oct-rem(14);
  padding: 0 0 0 oct-rem(16);
  list-style: none;

  &--video {
    flex-direction: column;
    align-items: center;

    .oct-media {
      width: oct-rem(216);
      padding-top: oct-rem(384);
      background-color: $oct-theme--neutral-10;
      border-radius: oct-rem(4);
    }
  }

@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  gap: oct-rem(32);
  padding-left: oct-rem(64);

  &--video {
    padding-left: 0;

    .oct-media {
      width: oct-rem(256);
      padding-top: oct-rem(455);
    }
  }
}
}

.ss-treatment-media__item {
  margin: 0;
  flex: 0 0 auto;
  width: (216%/359)*100;
  padding: 0;

  &[role="separator"] {
    width: oct-rem(1);
  }

  &::v-deep {
    .oct-media {
      background-color: $oct-theme--neutral-10;
    }
  }

@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  width: oct-rem(256);

  &[role="separator"] {
    width: oct-rem(32);
  }
}
}

.ss-treatment-media__uploader {
  position: relative;
  width: 100%;
  padding-top: 100%;
  background-color: $oct-theme--neutral-10;
}

.ss-treatment-media__input {
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ss-treatment-media__image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.ss-treatment-menu-list {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: oct-rem(16);
}

.ss-treatment-menu-list__content {
  display: flex;
  align-items: center;
  padding: oct-rem(2) 0 0 oct-rem(2);
  gap: oct-rem(10);
}

.ss-treatment-menu-list__text {
  font-size: oct-rem(20);
  line-height: 1;
}

.ss-treatment-reservation-date__content {
  display: flex;
  flex-direction: column;
  gap: oct-rem(32);
}

.ss-treatment-reservation-date__setting {
  display: flex;
  flex-direction: column;
  gap: oct-rem(16);

@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  gap: oct-rem(32);
}
}

.ss-treatment-reservation-date__selection {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: oct-rem(8);

  &::v-deep .oct-select__native-input {
    width: 100%;
  }

@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  margin-bottom: oct-rem(-16);
}
}

.ss-treatment__note {
  margin: oct-rem(16) 0 0;
}

.ss-treatment__note-text {
  font-size: oct-rem(14);
  line-height: 1.5;
  color: $oct-theme--neutral-50;
}

.ss-treatment-action {
  flex: 1 1 50%;
  display: flex;
  flex-direction: column;
  gap: oct-rem(4);
}

.ss-treatment-action__caption {
    font-size: oct-rem(10);
    line-height: 1.5;
    color: $oct-theme--neutral-50;
    margin: 0;
}

.ss-treatment__action {
  flex: 1 1 auto !important;
}

.ss-treatment__customer-email {
  display: none;
}

/* Lightbox */
.ss-treatment-lightbox {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: $oct-theme--surface;
  z-index: 100;

  .swiper-container {
    width: 100%;
    height: 100%;

    &::v-deep .oct-media__image {
      object-fit: contain;
    }
  }

@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  .swiper-container {
    width: 100%;
    height: 100%;

    &::v-deep .oct-media {
      width: oct-rem(554);
      padding-top: oct-rem(554);
    }

    &::v-deep .oct-media__image {
      object-fit: contain;
    }
  }
}
}

.ss-treatment-lightbox__media {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.ss-treatment-lightbox-thumbs {
  position: absolute;
  right: 0;
  left: 0;
  bottom: oct-rem(16);
  margin: 0;
  display: flex;
  justify-content: center;
  gap: oct-rem(8);
  padding: 0;
  list-style: none;
  z-index: 100;
}

.ss-treatment-lightbox-thumbs__item {
  width: oct-rem(44);
  height: oct-rem(44);

  &--active {
    border: oct-rem(1) solid $oct-theme--primary;
  }

@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  width: oct-rem(64);
  height: oct-rem(64);
}
}

.ss-treatment-lightbox__close {
  position: absolute;
  top: oct-rem(16);
  right: oct-rem(16);
  width: oct-rem(32);
  height: oct-rem(32);
  cursor: pointer;
  z-index: 100;
}

/* Transition */
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>